function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxOn = function SvgCheckboxOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 33h-11c-1.9 0-3.5-1.6-3.5-3.5v-11c0-1.9 1.6-3.5 3.5-3.5h11c1.9 0 3.5 1.6 3.5 3.5v11c0 1.9-1.6 3.5-3.5 3.5z",
    style: {
      fill: "none",
      stroke: "#bbb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00cc67"
    },
    d: "m17.7 23.7 2.2-2.1 3 2.9 5.2-5.2 2.2 2.1-7.4 7.4z"
  }));
};
export default SvgCheckboxOn;